import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import useFetchAemBrspdContents from "../../../../../shared/hooks/useFetchAemBrspdContents";
import ApiUrls from "../../../Utils/axr";
import { errorConditionGTM } from "../../../Utils/googleTags";

type homeFooterContentDetailsInitialStateType = {
  homeFooterPageContent: any;
  loading: boolean;
  error: any;
};
const initialState: homeFooterContentDetailsInitialStateType = {
  homeFooterPageContent: null,
  loading: false,
  error: null,
};
const host = window?.location?.host;
const file = 'footer-home-content.json'

export const getHomeFooterPageContent = createAsyncThunk(
  "get/homeFooter-page/content",
  async () => {
    try {
      const response = await useFetchAemBrspdContents({
        [ApiUrls.aem_content]: `${file}?appName=${host}`,
      });
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

const homeFooterContentDetailSlice = createSlice({
  name: "homeFooter-page/Details",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getHomeFooterPageContent.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getHomeFooterPageContent.fulfilled, (state, action) => {
      state.homeFooterPageContent = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getHomeFooterPageContent.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "home footer AEM Content",
        action.error?.message,
        action?.type
      );
      state.homeFooterPageContent = null;
      state.loading = false;
      state.error = action.error;
    });
  },
});

export default homeFooterContentDetailSlice.reducer;
